import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import '../css/style.css';
import { BsTelephone, BsGeoAlt, BsBuilding } from 'react-icons/bs';
import { FaUser, FaRegIdCard } from "react-icons/fa";
import { MdEmail } from 'react-icons/md';
import builder from '../utils/builderWithLocale';
import Loader from "./kontakt-loader";
import { getLocalizedText } from '../utils/textLocalization';

function Kontakt() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [list, setList] = useState([]);

  // Get localized text
  const quickContactTitleText = getLocalizedText('contact.quick_contact_title');
  const quickContactText = getLocalizedText('contact.quick_contact');
  const callUsText = getLocalizedText('contact.call_us');
  const telText = getLocalizedText('contact.tel');
  const billingTitleText = getLocalizedText('contact.billing_title');
  const billingInfoText = getLocalizedText('contact.billing_info');
  const vatIdText = getLocalizedText('contact.vat_id');
  const registryText = getLocalizedText('contact.registry');
  const fileNumberText = getLocalizedText('contact.file_number');

  useEffect(() => {
    document.title = getLocalizedText('contact.page_title');
    builder.get("kontakt").then(res => {
      setData(res.data);
      setList(res.data.prvniRadek.zastupci)
      setLoading(false)
    })
  }, [])

  if (loading) {
    return (
      <>
        <Loader />
      </>
    )
  }

  return (
    <motion.div
      key="kontakt"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
      className="kontakt-container"
    >
      <div className="top-contact">
        <div className="contact-title">{quickContactTitleText}</div>
        <div className="contact-phone">
          <div className="contact-label">{callUsText}</div>
          <div className="contact-item">
            <span className="contact-value tel">{telText} {data.rychlyKontakt.telefon}</span>
          </div>
        </div>
        <div className="contact-email">
          <div className="contact-label">{quickContactText}</div>
          <div className="contact-item">
            <a href={"mailto:" + data.rychlyKontakt.email} className="contact-value email">{data.rychlyKontakt.email.toUpperCase()}</a>
          </div>
        </div>
      </div>
      
      <div className="contact-content">
        {/* E-shop zabírá plnou šířku nahoře */}
        <div className="contact-card e-shop-card">
          <h2 className="card-title">{data.prvniRadek.nazev}</h2>
          <div className="card-content">
            <div className="address-block">
              <p className="info-content"><BsBuilding className="info-icon" /> {data.prvniRadek.jmenoFirmy}</p>
              <p className="info-content"><BsGeoAlt className="info-icon" /> {data.prvniRadek.adresa}</p>
              <p className="info-content" style={{marginLeft: "30px"}}>{data.prvniRadek.mesto}, {data.prvniRadek.psc}</p>
            </div>
            
            <div className="contact-regions">
            {list.map(element => (
              <div className="contact-region" key={element.nazev}>
                <h3 className="info-title">{element.nazev}:</h3>
                {element.jmeno && (
                  <p className="info-content"><FaUser className="info-icon" /> {element.jmeno}</p>
                )}
                <p className="info-content"><BsTelephone className="info-icon" /> {telText} {element.telefon}</p>
                <p className="info-content"><MdEmail className="info-icon" /> <a href={"mailto:" + element.email} className="email">{element.email}</a></p>
              </div>
            ))}
            </div>
          </div>
        </div>
        
        {/* Reklamace a International na jednom řádku */}
        <div className="contact-row">
          <div className="contact-card reklamace-card">
            <h2 className="card-title">{data.druhyRadek.reklamace.nazev}</h2>
            <div className="card-content">
              <p className="info-content"><BsBuilding className="info-icon" /> {data.druhyRadek.reklamace.jmenoFirmy}</p>
              <p className="info-content"><BsGeoAlt className="info-icon" /> {data.druhyRadek.reklamace.adresa}</p>
              <p className="info-content" style={{marginLeft: "5px"}}> {data.druhyRadek.reklamace.mesto}, {data.druhyRadek.reklamace.psc}</p>
              
              <p className="info-content info-spacing"><BsTelephone className="info-icon" /> {telText} {data.druhyRadek.reklamace.telefon}</p>
              <p className="info-content"><MdEmail className="info-icon" /> <a href="mailto:reklamace@zookee.cz" className="email">{data.druhyRadek.reklamace.email}</a></p>
              
              <p className="info-content info-note"
                dangerouslySetInnerHTML={{ __html: data.druhyRadek.reklamace.text }}>
              </p>
            </div>
          </div>
          
          <div className="contact-card international-card">
            <h2 className="card-title">{data.druhyRadek.malyBox.nazev}</h2>
            <div className="card-content">
              <div className="international-content international-content-data" style={{display: "block", position: "relative", top: "50px"}}>
                <p className="info-content inernational-content-email"><FaRegIdCard className="info-icon" /> {data.druhyRadek.malyBox.pozice}</p>
                <p className="info-content inernational-content-email"><FaUser className="info-icon" /> {data.druhyRadek.malyBox.jmeno}</p>
                <p className="info-content inernational-content-email"><BsTelephone className="info-icon" /> {telText} {data.druhyRadek.malyBox.telefon}</p>
                <p className="info-content inernational-content-email"><MdEmail className="info-icon" /> <a href={"mailto:" + data.druhyRadek.malyBox.email} className="email">{data.druhyRadek.malyBox.email}</a></p>
              </div>
            </div>
          </div>
        </div>
        
        {/* Fakturační údaje opět přes celou šířku dole */}
        <div className="contact-card fakturacni-card">
          <h2 className="card-title">{billingTitleText}</h2>
          <div className="card-content">
            <div className="fakturacni-columns">
              <div className="fakturacni-column">
                <p className="info-content"><BsBuilding className="info-icon" /> {data.fakturacni.nazev}</p>
                <p className="info-content"><BsGeoAlt className="info-icon" /> {data.fakturacni.adresa}</p>
                <p className="info-content" style={{marginLeft: "30px"}}>{data.fakturacni.mesto}, {data.fakturacni.psc}</p>
              </div>
              
              <div className="fakturacni-column">
                <p className="info-content">{billingInfoText} {data.fakturacni.ico}</p>
                <p className="info-content">{vatIdText} {data.fakturacni.dic}</p>
                <p className="info-content">{registryText} {data.fakturacni.or}</p>
                <p className="info-content">{fileNumberText} {data.fakturacni.spisovaZnacka}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default Kontakt;